var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-content"},[_c('iframe',{staticClass:"pdf-content",attrs:{"src":_vm.pdfSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }